import fetch from 'auth/FetchInterceptor'

const restService = {}

restService.getProductList = function () {
  return fetch({
    url: '/api/info/product_info',
    method: 'get'
  })
}

restService.getProductDesign = function (prodId) {
  return fetch({
    url: '/api/loan/request_design/',
    method: 'get',
    params: {
      prod_id: prodId
    }
  })
}

restService.submitLoanRequest = function (prodId, gRecaptchaResponse, formData) {
  return fetch({
    url: '/api/loan/request_save/',
    method: 'POST',
    params: {
      prod_id: prodId,
      cust_id: 0,
      g_recaptcha_response: gRecaptchaResponse
    },
    data: formData
  })
}

restService.createInvoice = function (invoice) {
  return fetch({
    url: '/api/qpay/create_invoice/',
    method: 'post',
    data: invoice
  })
}

restService.checkInvoice = function (invoiceId) {
  return fetch({
    url: '/api/qpay/check_invoice/',
    method: 'get',
    params: {
      invoiceId: invoiceId
    }
  })
}

export default restService